import { useTranslation } from "react-i18next";
import e404 from "./assets/images/404.png";
import { Link } from "react-router-dom";

export default function NotFound(){
    const { t, i18n } = useTranslation();
    return (
        <div style={{textAlign: "center", marginTop: "30vh", color: "#999", padding: "0 30px"}}>
            <img 
                src={e404}
                alt="404 error"
                style={{
                    width: "50vw"
                }}
            />
            <br />
            <br />
            {t('notFound.label')}
            <br />
            <br />
            <Link to="/" className="primary-btn">{t('return.label')}</Link>

        </div>
    )
}